module.exports = __webpack_public_path__ + "static/img/r-3-3.7ad2eac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-3/r-3-3.png
// module id = iRKS
// module chunks = 0